import request from "../Utils/Request";

export function deleteData(url: string) {
  return request.delete(url);
}
